import { useEffect, useState } from "react";
import { formatDateWithTime } from "../../optionstTabs/preview/dateHelpers";
import "./matchScore.sass";

export default function MatchScore({
  matchData = null,
  homeTeam = {},
  awayTeam = {},
  score = { home: 0, away: 0 },
  competition = "",
  date = "",
  venue = "",
  status = "pending",
}) {
  const [displayData, setDisplayData] = useState(null);

  // Actualizar displayData cuando recibimos matchData como prop
  useEffect(() => {
    if (matchData) {
      setDisplayData(matchData);
    } else {
      // Usar props como fallback si no hay matchData
      setDisplayData({
        homeTeam: homeTeam,
        awayTeam: awayTeam,
        score: score,
        competition: competition,
        date: date,
        venue: venue,
        status: status,
      });
    }
  }, [matchData, homeTeam, awayTeam, score, competition, date, venue, status]);

  // Determinar si mostrar VS o - según el estado del partido
  const getDividerText = () => {
    const matchStatus = displayData?.status || "";
    // Si el partido no ha empezado o fue cancelado, mostrar VS
    if (
      matchStatus === "clarosports-next-game" ||
      matchStatus === "clarosports-error-game"
    ) {
      return "VS";
    }
    // Si el partido está en progreso o finalizado, mostrar -
    return "-";
  };

  // Obtener la clase CSS para el score según el resultado
  const getScoreClass = (team) => {
    const resultClass = team?.resultClass || "";
    if (resultClass === "clarosports-winner") {
      return "score-value--winner";
    } else if (resultClass === "clarosports-loser") {
      return "score-value--loser";
    } else if (resultClass === "clarosports-draw") {
      return "score-value--draw";
    }
    return "";
  };

  if (!displayData) {
    return null;
  }

  return (
    <div className="match-score-container">
      {/* Encabezado con equipos y puntuación */}
      <div className="match-score-header">
        {/* Equipo Local */}
        <div className="team-section team-section--home">
          <div className="team-info">
            <img
              src={displayData.homeTeam?.logo || ""}
              alt={displayData.homeTeam?.name}
              className="team-logo"
              onError={(e) => (e.target.src = "https://via.placeholder.com/50")}
            />
            <span className="team-name">{displayData.homeTeam?.name || "Equipo Local"}</span>
          </div>
        </div>

        {/* Puntuación Central */}
        <div className="score-section">
          <div className={`score-value ${getScoreClass(displayData.homeTeam)}`}>
            {displayData.score?.home || 0}
          </div>
          <div className="score-divider">{getDividerText()}</div>
          <div className={`score-value ${getScoreClass(displayData.awayTeam)}`}>
            {displayData.score?.away || 0}
          </div>
        </div>

        {/* Equipo Visitante */}
        <div className="team-section team-section--away">
          <div className="team-info team-info--away">
            <span className="team-name">{displayData.awayTeam?.name || "Equipo Visitante"}</span>
            <img
              src={displayData.awayTeam?.logo || ""}
              alt={displayData.awayTeam?.name}
              className="team-logo"
              onError={(e) => (e.target.src = "https://via.placeholder.com/50")}
            />
          </div>
        </div>
      </div>

      {/* Información del partido */}
      <div className="match-info">
        <div className="match-details">
          <span className="competition">{displayData.competition}</span>
          <span className="date-time">
            {displayData?.date ? formatDateWithTime(displayData.date) : ""}
          </span>
        </div>
      </div>
      <div className="match-score-footer">
        <div className="match-score-footer-title">
          {matchData?.matchInfo?.venue && (
            <div className="footer-title-item">
              <span className="footer-title-label">SEDE:</span>
              <span className="footer-title-value">{matchData.matchInfo.venue.toUpperCase()}</span>
            </div>
          )}

          {matchData?.soccerData?.referee && (
            <div className="footer-title-item">
              <span className="footer-title-label">ÁRBITRO:</span>
              <span className="footer-title-value">{matchData.soccerData.referee.toUpperCase()}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}